// extracted by mini-css-extract-plugin
export var animationContainer = "_gf-0";
export var asteriskIcon = "_gf-8";
export var conversationLeftSection = "_gf-4";
export var conversationListItem = "_gf-3";
export var conversationMiddleSection = "_gf-5";
export var conversationRightSection = "_gf-6";
export var detailsContent = "_gf-1";
export var listContainer = "_gf-7";
export var modalContent = "_gf-2";